import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import "./output.css";
import Login from "./Pages/Login/index";
import Dashboard from "./Pages/Dashboard/index";
import Admin from "./Pages/admin/admin";
import Show from "./Pages/Editors/ShowsEditor";
import NotFound from "./Components/404";
import ViewShortPost from "./Pages/View Show Post";
import Ticket from "./Pages/Editors/TicketEditor";
import Register from "./Pages/Register/index";
import UpdateShow from "./Pages/Editors/ShowsEditor/updateShow";
import ViewLongPost from "./Pages/View Tickets Post";
import UpdateTicket from "./Pages/Editors/TicketEditor/updateTicket";
import ChangePassword from "./Pages/admin/changepw";
import { Tooltip as ReactTooltip } from "react-tooltip";
import TicketPrices from "./Pages/Editors/TicketPricesEditor";
import UpdateCommunity from "./Pages/Editors/TicketPricesEditor/updateTicketPrices";
import ViewCommunityPost from "./Pages/View Ticket Prices Post";
import Video from "./Pages/Editors/VideosEditor";
import UpdateVideo from "./Pages/Editors/VideosEditor/updateVideo";
import ViewVideoPost from "./Pages/View Video Post";
import Sidebar from "./Components/base/sidebar";
import ViewBuyLinkPost from "./Pages/View Buy Link Post";
import BuyLink from "./Pages/Editors/BuyLinksEditor";
import UpdateBuyLink from "./Pages/Editors/BuyLinksEditor/updateBuyLinks";
import ViewGalleryPost from "./Pages/View Gallery";
import UpdateGallery from "./Pages/Editors/GalleryEditor/updateGallery";
import Gallery from "./Pages/Editors/GalleryEditor";
import ViewSeatPlan from "./Pages/View Seat Plan";
import SeatPlan from "./Pages/Editors/SeatPlanEditor";
import ViewNewsMedia from "./Pages/View News Media";
import NewsMedia from "./Pages/Editors/NewsMediaEditor";
import UpdateNewsMedia from "./Pages/Editors/NewsMediaEditor/updateNewsMedia";
import UpdateSeatPlan from "./Pages/Editors/SeatPlanEditor/updateSeatPlan";
import { Toaster } from 'sonner'; 
// New Menus
import ViewUserMenu from "./Pages/View User Menu";
import UpdateCommunityV2 from "./Pages/Editors/TicketPricesEditor/updateTicketPricesV2";

// Private Layout (with Sidebar, etc.)
function PrivateLayout() {
  return (
    <div className="grid h-screen grid-cols-[16rem_1fr] font-graphik">
      <Sidebar />
      <main className="col-start-2 row-start-1 flex justify-center bg-gray-200">
        <Routes>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/show" element={<Show />} />
          <Route path="/view/post/Show" element={<ViewShortPost />} />
          <Route path="/update/show" element={<UpdateShow />} />
          <Route path="/ticket-prices" element={<TicketPrices />} />
          <Route path="/update/ticket-prices" element={<UpdateCommunity />} />
          <Route path="/view/post/ticket-prices" element={<ViewCommunityPost />} />
          <Route path="/ticket" element={<Ticket />} />
          <Route path="/view/post/ticket" element={<ViewLongPost />} />
          <Route path="/update/ticket" element={<UpdateTicket />} />
          <Route path="/video" element={<Video />} />
          <Route path="/view/post/video" element={<ViewVideoPost />} />
          <Route path="/update/video" element={<UpdateVideo />} />
          <Route path="/view/post/buy-links" element={<ViewBuyLinkPost />} />
          <Route path="/buy-link" element={<BuyLink />} />
          <Route path="/update/buy-links" element={<UpdateBuyLink />} />
          <Route path="/update/gallery" element={<UpdateGallery />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/view/post/gallery" element={<ViewGalleryPost />} />
          <Route path="/seat-plan" element={<SeatPlan />} />
          <Route path="/view/post/seat-plan" element={<ViewSeatPlan />} />
          <Route path="/view/post/news-media" element={<ViewNewsMedia />} />
          <Route path="/news-media" element={<NewsMedia />} />
          <Route path="/update/news-media" element={<UpdateNewsMedia />} />
          <Route path="/update/seat-plan" element={<UpdateSeatPlan />} />
          <Route path="*" element={<NotFound />} />
          {/* New menus */}
          <Route path="/view/post/menu" element={<ViewUserMenu />} />
          <Route path="/update/ticket-prices2" element={<UpdateCommunityV2 />} />
        </Routes>
      </main>
    </div>
  );
}

// Public Layout (for Login, Register, etc.)
function PublicLayout() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <ReactTooltip id="edit" place="right" content="Edit" />
      <ReactTooltip id="preview" place="right" content="Preview" />
      <ReactTooltip id="delete" place="right" content="Delete" />
      <ReactTooltip id="feature" place="right" content="Feature Coming Soon" />
      <Toaster richColors position="top-right" />

      {/* Conditionally render layout based on the current route */}
      <Routes>
        <Route path="/login" element={<PublicLayout />} />
        <Route path="/" element={<PublicLayout />} />
        <Route path="/register" element={<Register />} />

        {/* For all other routes, render the Private Layout */}
        <Route path="*" element={<PrivateLayout />} />
      </Routes>
    </Router>
  );
}
